import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PagedTable from '../../Reusable/Lists/PagedTable';
import { Divider, Button, Grid } from 'semantic-ui-react';
import useListOtherParticipations from '../../Hooks/Users/OtherParticipation/useListOtherParticipations';
import { useParams } from 'react-router-dom';
import SubNavigation from '../User/SubNavigation';
import { StateContext } from '../../Context/StateContext';

const OtherParticipationList = (props) => {

    const { id } = useParams();
    const { t } = useTranslation();
    const { otherParticipations, listOtherParticipations } = useListOtherParticipations();
    const { userDetailBackRoute } = useContext(StateContext);

    // Fetch one to ones
    useEffect(() => {
        (async () => {
            await listOtherParticipations(id);
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // add detail link to one to one array
    useEffect(() => {
        otherParticipations.map(item => {
            item.viewUrl = 'detail/';
            item.link=t('general.view');
            return item;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[otherParticipations]);
    
    return (
        <div>
            <SubNavigation id={id} activePage='participations' />

            <Grid stackable columns={2} className="add-margin">
                <Grid.Column><h1>{t('heading.otherParticipations')}</h1></Grid.Column>
                <Grid.Column>
                    <Button floated='right' onClick={() => props.history.push('/user/' + id + '/participation/new')}>{t('otherParticipation.add')}</Button>
                </Grid.Column>
            </Grid>
                
            <PagedTable unstackable striped celled compact='very'
                header={[
                    t('otherParticipation.date'),
                    t('otherParticipation.type'),
                    t('otherParticipation.description'),
                    ''
                ]}
                content={otherParticipations}
                contentKeys={[
                    {key: 'Date', type: 'date'},
                    {key: 'ParticipationTypeName'},
                    {key: 'Description', type: 'firstChars', limit: 100},
                    {key: 'link', type: 'url', urlKey:'viewUrl', cellAlign: 'left', targetKey: 'Id'},
                ]}
                pageSize='20'
            />

            <Divider />
            <Button onClick={() => props.history.push(userDetailBackRoute || '/user/list')}>{t('general.backToUserList')}</Button>
                
        </div>
    );

}

export default OtherParticipationList;
